import { defineModule, } from 'direct-vuex';

export interface ProfileState {
	profileUpdateTitle: string | null;
	profileUpdateContent: string | null;
}

export default defineModule({
	namespaced: true as const,
	state: {
		profileUpdateTitle: null,
		profileUpdateContent: null,
	} as ProfileState,
	getters: {
	},
	mutations: {
		showDefaultUpdateMsg(state) {
			state.profileUpdateTitle = 'Your profile has been updated';
		},
		showDelayedUpdatedMsg(state) {
			state.profileUpdateTitle = 'Your profile has been updated';
			state.profileUpdateContent = 'It may take up to 48 hours for this change to reflect on your account';
		},
		reset(state) {
			state.profileUpdateTitle = null;
			state.profileUpdateContent = null;
		},
	},
});
